export default __webpack_public_path__ + "1270629f9fd37be49c562c13ea338b9c.png";